import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Premera Blue Cross",
  shortName: "Premera",
  slug: "premera-insurance",
  seoTitle: "Premera Blue Cross TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Premera Blue Cross? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Premera plan in Coral Springs, FL.",
  seoKeywords:
    "Premera TMS coverage, Premera Blue Cross TMS therapy, Premera depression treatment Florida, Premera mental health benefits Coral Springs FL, Premera SAINT TMS",
  planType: "Blue Cross Blue Shield affiliate health insurance plan",
  planRegion: "Washington state, Alaska, and select regions",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "Premera Blue Cross is an independent licensee of the Blue Cross Blue Shield Association, serving members in Washington state and Alaska. Premera plans typically include behavioral health benefits that may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. Because Premera offers a range of plan types — from employer-sponsored group plans to individual marketplace policies — coverage for TMS, accelerated protocols, and other advanced depression treatments varies significantly by individual plan.",
  officialResourceUrl: "https://www.premera.com/",
  officialResourceLabel: "Premera Blue Cross official website",
};

export const PremeraInsurance = () => <InsurancePageTemplate config={config} />;
export default PremeraInsurance;
